import { isNil } from 'core/service/lib/type-check'
import Mustache from 'mustache'
import PolicyValueTable from './policy-value/policy-value-table'
import { Redirect } from 'react-router-dom'
import PATH from 'quick-quote/constants/path'
import MESSAGES from 'core/data-model/constants/validation-messages'
import BIMESSAGES from 'core/data-model/constants/bi-messages'
import { FormFeedback, FormGroup } from 'reactstrap'
import ProfileSnapshot from './profile-summary/profile-snapshot'
import RiderBenefits from 'quick-quote/product-common/benefit-illustration/components/rider-benefits'
import {
  FlexiHealthLegalDisclaimer,
  FlexiHealthTaxBenefit,
  LegalConditionDisclaimerMarketConduct,
} from './flexi-health-legal-disclaimer'
import { isPlatinum } from 'core/service/benefit-illustration/products/flexi-health'

import { SidebarMenu } from 'quick-quote/components'
import ProductBenefits from './product-benefits/product-benefits'
import { isProductForReuseFlexiHealth } from 'quick-quote/product-flexi-health/benefit-illustration/selectors'

const BenefitIllustration = ({
  displayProduct,
  riders,
  genderLabel,
  age,
  hasProductSelected,
  sumAssured$,
  basicPremium$,
  totalPremium,
  totalRiderPremium,
  calculatedCoveragePeriod,
  calculatedPaymentPeriod,
  selectedModelFactorLabel,
  selectedModelFactorPeriod,
  hasNonLevelRider,
  coveragePlanStartDate,
  legalDisclaimerEndDate,
  policyValue,
  isBlockedPdfGeneration,
  isBlockedEnteringESub,
  profileSummaryHeader,
  taxDeduction,
  isBancAgent,
  isReviseQQ,
}) => {
  if (!hasProductSelected) {
    return <Redirect to={PATH.PRODUCT_SELECTION} push />
  } else if (isNil(displayProduct)) return <div id="benefit-illustration-invalid" />
  else {
    return (
      <div id="benefit-illustration">
        <div className="content">
          <ProfileSnapshot
            displayProduct={displayProduct}
            riders={riders}
            genderLabel={genderLabel}
            age={age}
            sumAssured={sumAssured$.value}
            basicPremium={basicPremium$.value}
            totalPremium={totalPremium}
            policyValue={policyValue}
            totalRiderPremium={totalRiderPremium}
            selectedModelFactorLabel={selectedModelFactorLabel}
            calculatedCoveragePeriod={calculatedCoveragePeriod}
            calculatedPaymentPeriod={calculatedPaymentPeriod}
            hasNonLevelRider={hasNonLevelRider}
            profileSummaryHeader={profileSummaryHeader}
            summaryTableHeader={({ displayProduct }) =>
              Mustache.render(BIMESSAGES.FLEXI_HEALTH_BASIC_PLAN_DETAILS, {
                basicplan: isProductForReuseFlexiHealth(displayProduct)
                  ? displayProduct.basicPlanName
                  : BIMESSAGES.BASIC_PLAN,
                name: isProductForReuseFlexiHealth(displayProduct) ? '' : displayProduct.fullNameThai,
              })
            }
            isReviseQQ={isReviseQQ}
          />

          <ProductBenefits
            displayProduct={displayProduct}
            sumAssured={sumAssured$.value}
            basicPremium={basicPremium$.value}
            calculatedPaymentPeriod={calculatedPaymentPeriod}
            calculatedCoveragePeriod={calculatedCoveragePeriod}
            policyValue={policyValue}
            benefitSummaryHeader={({ displayProduct }) => displayProduct.fullNameThai}
          />

          {riders.length > 0 && <RiderBenefits />}

          <FlexiHealthLegalDisclaimer isPlatinum={isPlatinum({ riders })} />

          <PolicyValueTable
            policyValue={policyValue}
            basicPlan={displayProduct}
            title={BIMESSAGES.POLICY_VALUE_TABLE}
          />

          <FlexiHealthTaxBenefit taxDeduction={taxDeduction} />

          <LegalConditionDisclaimerMarketConduct
            startDate={coveragePlanStartDate}
            endDate={legalDisclaimerEndDate}
            isBancAgent={isBancAgent}
          />

          {isBlockedEnteringESub ? (
            <FormGroup className="has-warning">
              <FormFeedback className={'eligibility-message attached-icon'}>
                <div> {MESSAGES.RULE_ENTER_ESUB_PREREQUISITE} </div>
              </FormFeedback>
            </FormGroup>
          ) : (
            ''
          )}
        </div>
        <SidebarMenu
          mainMenu={[
            {
              text: BIMESSAGES.SUMMARY_OF_MAIN_AND_ADDITIONAL_CONTRACTS,
              id: 'profile-summary',
              isSub: false,
            },
            {
              text: 'รายละเอียดของสัญญาหลัก',
              id: 'product-benefits',
              isSub: false,
            },
            {
              text: BIMESSAGES.POLICY_VALUE_TABLE,
              id: 'policy-value',
              isSub: false,
            },
            {
              text: BIMESSAGES.LEGAL_DISCLAIMER,
              id: 'legal-disclaimer-market-conduct',
              isSub: false,
            },
          ]}
        />
      </div>
    )
  }
}

export default BenefitIllustration
